import LineChart from "./recharts/LineChart";

export default {
    LineChart
}